import { GetConstraintsResponse } from '../../api/typegen/application/constraints/get';
import { QueryStatus, useQuery } from '@tanstack/react-query';
import getApplicationConstraintsApiCall from '../../api/calls/getApplicationConstraintsApiCall';
import useAuth from './useAuth';

interface UseLoanConstraintsQuery {
  status: QueryStatus;
  applicationConstraints?: GetConstraintsResponse;
}

const useLoanClientConstraintsQuery = (): UseLoanConstraintsQuery => {
  const { token } = useAuth();
  const query = useQuery(
    ['getClientConstraintsApiCall', token],
    getApplicationConstraintsApiCall,
    {
      enabled: !!token,
      staleTime: Infinity,
    },
  );

  return {
    status: query.status,
    applicationConstraints: query.data,
  };
};

export default useLoanClientConstraintsQuery;
